module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"annotationCard.annotation":"Annotation","annotationCard.annotationDate":"Annotation Date"}}')
  delete Component.options._Ctor
}
